import { connect } from 'react-redux';
import { getIsMobile } from 'ha/modules/UI/selectors';
import { GlobalState } from 'ha/types/store';

import { BlogShareToSocialNetworks } from '../components/BlogShareToSocialNetworks';

const BlogShareToSocialNetworksContainer = connect((state: GlobalState) => ({
  isMobile: getIsMobile(state),
}))(BlogShareToSocialNetworks);
export { BlogShareToSocialNetworksContainer };
